import moment from 'moment';

// Define date formats for each locale
const dateFormats = {
  en: 'MM-DD-YY HH:mm', // US-English
  sv: 'YYYY-MM-DD HH:mm', // Swedish
  dk: 'YYYY-MM-DD HH:mm', // Danish
  de: 'YYYY-MM-DD HH:mm', // German
  it: 'DD.MM.YY HH:mm', // Italian
  es: 'DD-MM-YY HH:mm', // Spanish
  fr: 'DD/MM/YYYY HH:mm', // French
  fi: 'DD.MM.YYYY HH:mm', // Finnish
  th: 'DD/MM/YYYY HH:mm', // Thai
  gb: 'DD/MM/YY HH:mm', // GB-English
  pt: 'DD/MM/YYYY HH:mm', // Portuguese
  cn: 'YYYY-MM-DD HH:mm', // Chinese
  pl: 'DD.MM.YYYY HH:mm', // Polish
  timeOnly: 'HH:mm', // Time-only format (used for Start Time/End Time)
};

// Default locale if none is specified
const defaultLocale = 'en';

/**
 * Formats a UNIX timestamp (seconds since epoch) based on the specified locale.
 * 
 * @param {number} timestamp - The UNIX timestamp (seconds since epoch).
 * @param {string} [locale=defaultLocale] - The locale code for formatting (e.g., 'en', 'sv').
 * @param {boolean} [showTime=true] - Whether to include the time in the format.
 * @returns {string} - The formatted date string.
 */
export const formatDateByLocale = (timestamp, locale = defaultLocale, showTime = true) => {
  // Use default locale ('en') if dateFormats[locale] is undefined or dateFormats is empty
  const format = showTime 
    ? dateFormats[locale] || dateFormats[defaultLocale] // Fallback to default format
    : (dateFormats[locale] || dateFormats[defaultLocale]).split(' ')[0]; // Use only the date part

  // Convert timestamp (seconds) to milliseconds for moment compatibility
  const date = moment.unix(timestamp);

  // Return the formatted date or fallback to a default message if invalid
  return date.isValid() ? date.format(format) : 'Invalid Date';
};
